NP.EmoticonData = [
		{ name : [ '웃음' ], url : 'emo_smile' },
    { name : [ '하하' ], url : 'emo_laugh' },
    { name : [ '윙크' ], url : 'emo_wink' },
    { name : [ '헤헤' ], url : 'emo_hehe' },
    { name : [ '부끄' ], url : 'emo_shy' },
    { name : [ '메롱' ], url : 'emo_p' },
    { name : [ '브이' ], url : 'emo_v' },
    { name : [ '반짝' ], url : 'emo_twinkle' },
    { name : [ '반함' ], url : 'emo_love' },
    { name : [ '뽀뽀' ], url : 'emo_kiss' },
    { name : [ '도도' ], url : 'emo_proud' },
    { name : [ '느끼' ], url : 'emo_oily' },
    { name : [ '화남' ], url : 'emo_angry' },
    { name : [ '쳇', '찌릿' ], url : 'emo_askance' },
    { name : [ '활활' ], url : 'emo_fire' },
    { name : [ '멘붕' ], url : 'emo_mental' },
    { name : [ '발끈' ], url : 'emo_huffy' },
    { name : [ '한숨' ], url : 'emo_phew' },
    { name : [ '소심' ], url : 'emo_timid' },
    { name : [ '실망', '난처' ], url : 'emo_disappoint' },
    { name : [ '흑흑' ], url : 'emo_tear' },
    { name : [ '엉엉' ], url : 'emo_cry' },
    { name : [ '아픔' ], url : 'emo_sick' },
    { name : [ '천사' ], url : 'emo_angel' },
    { name : [ '악마' ], url : 'cha_devil' },
    { name : [ '딴청' ], url : 'emo_pretend' },
    { name : [ '쉿' ], url : 'emo_sh' },
    { name : [ '안보여' ], url : 'emo_blind' },
    { name : [ '멋쟁이' ], url : 'emo_style' },
    { name : [ '코피' ], url : 'emo_nosebleed' },
    { name : [ '풉' ], url : 'emo_poop' },
    { name : [ '삐침' ], url : 'emo_sulk' },
    { name : [ 'ㄷㄷ' ], url : 'emo_tremble' },
    { name : [ '썩소' ], url : 'emo_sneer' },
    { name : [ '깜짝' ], url : 'emo_surprise' },
    { name : [ '도둑' ], url : 'emo_thief' },
    { name : [ '으흣', '음흉' ], url : 'emo_wicked' },
    { name : [ '궁금' ], url : 'emo_wonder' },
    { name : [ '안경' ], url : 'emo_smart' },
    { name : [ '무관심' ], url : 'emo_indifference' },
    { name : [ '어질' ], url : 'emo_dizzy' },
    { name : [ '거품' ], url : 'emo_bubble' },
    { name : [ '우웩' ], url : 'emo_vomit' },
    { name : [ '피곤' ], url : 'emo_tired' },
    { name : [ '졸림' ], url : 'emo_sleepy' },
    { name : [ '당황' ], url : 'emo_embarrass' },
    { name : [ '묵', '주먹', '바위' ], url : 'obj_muk' },
    { name : [ '찌', '가위' ], url : 'obj_ji' },
    { name : [ '빠', '보' ], url : 'obj_pa' },
    { name : [ '좋아요', '최고' ], url : 'obj_like' },
    { name : [ '싫어요', '최악' ], url : 'obj_dislike' },
    { name : [ '경고' ], url : 'obj_ycard' },
    { name : [ '퇴장' ], url : 'obj_rcard' },
    { name : [ '입술' ], url : 'obj_lip' },
    { name : [ '눈알' ], url : 'obj_eye' },
    { name : [ '사랑', '하트' ], url : 'obj_heart' },
    { name : [ '이별' ], url : 'obj_brokenheart' },
    { name : [ '강아지' ], url : 'cha_dog' },
    { name : [ '고양이' ], url : 'cha_cat' },
    { name : [ '닭' ], url : 'cha_chicken' },
    { name : [ '돼지' ], url : 'cha_pig' },
    { name : [ '햄버거' ], url : 'food_burger' },
    { name : [ '피자' ], url : 'food_pizza' },
    { name : [ '치킨' ], url : 'food_chicken' },
    { name : [ '초밥' ], url : 'food_sushi' },
    { name : [ '라면' ], url : 'food_ramen' },
    { name : [ '짜장면' ], url : 'food_jajangmyeon' },
    { name : [ '도시락' ], url : 'food_lunch' },
    { name : [ '밥' ], url : 'food_rice' },
    { name : [ '계란' ], url : 'food_egg' },
    { name : [ '빵' ], url : 'food_bread' },
    { name : [ '붕어빵' ], url : 'food_bungeobbang' },
    { name : [ '핫도그1' ], url : 'food_hotdog1' },
    { name : [ '핫도그2' ], url : 'food_hotdog2' },
    { name : [ '도넛' ], url : 'food_donut' },
    { name : [ '케익' ], url : 'food_cake' },
    { name : [ '사탕' ], url : 'food_candy' },
    { name : [ '쿠키' ], url : 'food_cookie' },
    { name : [ '초콜렛' ], url : 'food_chocolate' },
    { name : [ '아이스크림' ], url : 'food_icecream' },
    { name : [ '사과' ], url : 'food_apple' },
    { name : [ '바나나' ], url : 'food_banana' },
    { name : [ '수박' ], url : 'food_watermelon' },
    { name : [ '레몬' ], url : 'food_lemon' },
    { name : [ '딸기' ], url : 'food_strawberry' },
    { name : [ '우유' ], url : 'food_milk' },
    { name : [ '커피' ], url : 'food_coffee' },
    { name : [ '칵테일' ], url : 'food_cocktail' },
    { name : [ '와인' ], url : 'food_wine' },
    { name : [ '맥주' ], url : 'food_beer' },
    { name : [ '소주' ], url : 'food_soju' },
    { name : [ '해' ], url : 'wea_sunny' },
    { name : [ '흐림', '구름' ], url : 'wea_cloudy' },
    { name : [ '무지개' ], url : 'wea_rainbow' },
    { name : [ '비' ], url : 'wea_rain' },
    { name : [ '눈', '눈사람' ], url : 'wea_snowman' },
    { name : [ '번개' ], url : 'aion_lightning' },
    { name : [ '트리' ], url : 'obj_tree' },
    { name : [ '유령' ], url : 'cha_ghost' },
    { name : [ '복' ], url : 'obj_bok' },
    { name : [ '돈' ], url : 'obj_money' },
    { name : [ '황금' ], url : 'obj_gold' },
    { name : [ '장미' ], url : 'obj_rose' },
    { name : [ '꽃다발' ], url : 'obj_flower' },
    { name : [ '선물' ], url : 'obj_gift' },
    { name : [ '폭죽' ], url : 'obj_firework' },
    { name : [ '초' ], url : 'obj_candle' },
    { name : [ '리본' ], url : 'obj_ribbon' },
    { name : [ '반지' ], url : 'obj_ring' },
    { name : [ '보석' ], url : 'obj_jewel' },
    { name : [ '왕관' ], url : 'obj_crown' },
    { name : [ '행운' ], url : 'obj_clover' },
    { name : [ '벌레' ], url : 'obj_bug' },
    { name : [ '부적' ], url : 'obj_talisman' },
    { name : [ '알약' ], url : 'obj_pill' },
    { name : [ '똥' ], url : 'obj_dung' },
    { name : [ '아이디어' ], url : 'obj_idea' },
    { name : [ '느낌표' ], url : 'obj_exclamation' },
    { name : [ '물음표' ], url : 'obj_question' },
    { name : [ '자전거' ], url : 'obj_bike' },
    { name : [ '자동차' ], url : 'obj_car' },
    { name : [ '비행기' ], url : 'obj_plane' },
    { name : [ '여권' ], url : 'obj_passport' },
    { name : [ '여행가방' ], url : 'obj_travel' },
    { name : [ '영화' ], url : 'obj_movie' },
    { name : [ '휴대폰' ], url : 'obj_cellphone' },
    { name : [ '카메라' ], url : 'obj_camera' },
    { name : [ '편지' ], url : 'obj_letter' },
    { name : [ '연필' ], url : 'obj_pencil' },
    { name : [ '축구' ], url : 'obj_soccer' },
    { name : [ '야구' ], url : 'obj_baseball' },
    { name : [ '경보' ], url : 'obj_siren' },
    { name : [ '주의' ], url : 'obj_caution' },
    { name : [ '19금' ], url : 'obj_19' },
    { name : [ '화살표' ], url : 'aion_arrow' },
    { name : [ '화살표_위' ], url : 'obj_arrow_up' },
    { name : [ '미션' ], url : 'aion_mission' },
    { name : [ '퀘스트' ], url : 'aion_quest' },
    { name : [ '슈고' ], url : 'aion_shugo' },
    { name : [ '강화석' ], url : 'aion_reinforce' },
    { name : [ '소금' ], url : 'aion_reinforce_w' },
    { name : [ '부활석' ], url : 'aion_revival' },
    { name : [ '수면' ], url : 'aion_zzz' },
    { name : [ '별' ], url : 'aion_star' },
    { name : [ '폭탄' ], url : 'aion_bomb' },
    { name : [ '해골' ], url : 'aion_skull' },
    { name : [ '차단' ], url : 'aion_block' },
    { name : [ '주문서' ], url : 'obj_scroll' },
    { name : [ '마법사' ], url : 'obj_magic' },
    { name : [ '빨간물약' ], url : 'aion_lpotion' },
    { name : [ '파란물약' ], url : 'aion_mpotion' },
    { name : [ '보라물약' ], url : 'aion_ppotion' },
    { name : [ '노란물약' ], url : 'aion_hpotion' },
    { name : [ '검사' ], url : 'bns_blademaster' },
    { name : [ '역사' ], url : 'bns_destroyer' },
    { name : [ '권사' ], url : 'bns_kungfufighter' },
    { name : [ '암살자' ], url : 'bns_assassin' },
    { name : [ '기공사' ], url : 'bns_forcemaster' },
    { name : [ '소환사' ], url : 'bns_summoner' },
    { name : [ '금' ], url : 'bns_gold' },
    { name : [ '은' ], url : 'bns_silver' },
    { name : [ '동' ], url : 'bns_bronze' },
    { name : [ '보패' ], url : 'bns_bope' },
    { name : [ '1단계' ], url : 'obj_lv1' },
    { name : [ '2단계' ], url : 'obj_lv2' },
    { name : [ '3단계' ], url : 'obj_lv3' },
    { name : [ '4단계' ], url : 'obj_lv4' }
	];
